const redirectPath = '/profile/necessary_items/edit';

export default defineNuxtRouteMiddleware(() => {
  const { state } = useUser();

  if (state.value.profile) {
    const profile = state.value.profile;

    // アッテルキャリアがONかつ氏名・生年月日・転職意欲の情報が未入力の場合にリダイレクトします。
    // https://app.zenhub.com/workspaces/attelu-615b96c61815cd0017106f6b/issues/attelu/attelu-toc/478

    const isNotSaved =
      profile.lastName === '' ||
      profile.firstName === '' ||
      profile.yearOfBirth === null ||
      profile.monthOfBirth === null ||
      profile.dayOfBirth === null ||
      profile.attributes.willingnessStatuses.careerChange === null;

    if (profile.settings.atteluCareerStatus === 1 && isNotSaved) {
      return navigateTo(redirectPath);
    }
  }
});
